module.exports = __webpack_public_path__ + "static/media/LazyAz_web2_preview.4a490b0e.jpg";